/**
 * Created by Anup on 8/7/2019.
 */
$(document).ready(function() {
    $('.wishlist').click(function(){
        $(this).hide();
        $('.remove_wishlist').show();
        //Scroll to top if cart icon is hidden on top
        $('html, body').animate({
            'scrollLeft' : $(".flyingHart").position().left
        });
        //Select item image and pass to the function
        var itemImg = $('.remove_wishlist');
        flyToElement($(itemImg), $('.flyingHart'));
    });

    $('.wishlist_collection').click(function(){
        $(this).hide();
        $( this ).parent().parent().find('.remove_wishlist_collection').show();

        $('html, body').animate({
            'scrollLeft' : $(".flyingHart").position().left
        });

        var itemImg = $( this ).parent().parent().find('.remove_wishlist_collection');
        flyToElement($(itemImg), $('.flyingHart'));
    });


});

$('.remove_wishlist').click(function(){
    $(this).hide();
    $('.wishlist').show();
});


function flyToElement(flyer, flyingTo) {
    var $func = $(this);
    var divider = 3;
    var flyerClone = $(flyer).clone();
    $(flyerClone).css({
        position: 'absolute',
        top: $(flyer).offset().top + "px",
        left: $(flyer).offset().left + "px",
        opacity: 1,
        'z-index': 99999
    });
    $('body').append($(flyerClone));
    var gotoX = $(flyingTo).offset().left + ($(flyingTo).width() / 2) - ($(flyer).width()/divider)/2;
    var gotoY = $(flyingTo).offset().top + ($(flyingTo).height() / 2) - ($(flyer).height()/divider)/2;

    $(flyerClone).animate({
            opacity: 0.9,
            left: gotoX,
            top: gotoY,
            //width: $(flyer).width()/divider,
            //height: $(flyer).height()/divider
        }, 500,
        function () {
            /* $(flyingTo).fadeOut('fast', function () {
             $(flyingTo).fadeIn('fast', function () {
             $(flyerClone).fadeOut('slow', function () {
             $(flyerClone).remove();
             });
             });
             });*/
            $(flyerClone).remove();
            setTimeout(function () {
                flyingTo.toggleClass('ssw-fave-adding-effect');
                setTimeout(function () {
                    flyingTo.toggleClass('ssw-fave-adding-effect');
                }, 200);
            }, 500);

        });
}